module.exports = __webpack_public_path__ + "650189d158af510e61c0ab221cfe93f8.svg";


//////////////////
// WEBPACK FOOTER
// ../images/sponsors/apress.svg
// module id = 400
// module chunks = 0